import React, { useEffect } from "react";
import { createPortal } from "react-dom";

interface ModalProps {
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Modal de overlay renderizado via Portal no document.body.
 * Escapa de qualquer ancestral com `transform` (que quebraria position:fixed),
 * trava o scroll do fundo e fecha no Esc / clique fora.
 * O painel filho deve chamar e.stopPropagation() no próprio onClick.
 */
const Modal: React.FC<ModalProps> = ({ onClose, children }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[1000] flex touch-manipulation items-center justify-center overflow-y-auto overscroll-contain bg-navy-900/60 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      {children}
    </div>,
    document.body
  );
};

export default Modal;
